// extracted by mini-css-extract-plugin
export default {"container":"styles_container__u9Vf-","title":"styles_title__6sjSD","resources":"styles_resources__kH6Bi","loader":"styles_loader__4J4+l","button":"styles_button__BQi1i"};